import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["hit"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ProductCard from '@scentregroup/shared/components/product-card';
import { discountedPriceRange, priceRange, discountPercentageRange } from '@scentregroup/shared/helpers/price-ranges';
import { displayMinimumPriceWithoutCurrency } from '../../../helpers/product-price';
import AnalyticsDataWrapper from '../../analytics-data-wrapper';
import SearchResult from '../search-result';
import style from '../index.module.scss';
import WestfieldProductCard from '../../westfield-product-card';
import makeUniqueProductId from '../../../helpers/make-unique-product-id';
import getUrlForHit from '../get-url-for-hit';
import { getFieldForSegment } from '../display-utils';
import { getEnvBool } from '../../../config';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

const getCommonProps = _ref => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref;
  const key = hit.objectID;

  const onClick = () => onResultClick(hit);

  const href = getUrlForHit(hit, context);
  const highlightField = getFieldForSegment(hit.segment);
  return {
    hit,
    key,
    index,
    onClick,
    href,
    highlightField
  };
};

const renderNationalStorefront = _ref2 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref2;
  const isOnlineDecommissionMode = getEnvBool(process.env.NEXT_PUBLIC_FEAT_FLAG_ONLINE_DECOMMISSION);
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "nationalStorefront",
    description: hit.hasMarketplaceShopSlug && !isOnlineDecommissionMode ? 'All stores & online' : 'All stores',
    className: style.storeRow,
    imageBgSize: "contain",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult"
  }));
};

const renderStore = _ref3 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref3;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "store",
    description: context.centre.title,
    className: style.storeRow,
    imageBgSize: "contain",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_1"
  })) : null;
};

const renderSite = _ref4 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref4;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "site",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_2"
  })) : null;
};

const renderService = _ref5 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref5;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "service",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_3"
  })) : null;
};

const renderLocalOffer = _ref6 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref6;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "offer",
    description: hit.storeTitles.join(', '),
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_4"
  })) : null;
};

const renderNationalOffer = _ref7 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref7;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "national-offer",
    description: hit.storeTitles.join(', '),
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_5"
  }));
};

const renderEvent = _ref8 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref8;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "event",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_6"
  })) : null;
};

const renderNews = _ref9 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref9;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "news",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_7"
  })) : null;
};

const renderLocalStory = _ref10 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref10;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "local-story",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_8"
  })) : null;
};

const renderNationalStory = _ref11 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref11;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "national-story",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_9"
  }));
};

const renderCentre = _ref12 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref12;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "centre",
    isTextBold: false,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_10"
  }));
};

const renderOnlineService = _ref13 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref13;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "online-service",
    isTextBold: false,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_11"
  }));
};

const renderNearCentreStore = _ref14 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref14;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "other-store",
    description: hit.centreName,
    className: style.otherStoreRow,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_12"
  }));
};

export const renderProduct = _ref15 => {
  var _discountedPriceRange, _hit$brand$name, _hit$brand, _hit$shop$retailer$sy, _hit$shop$retailer, _hit$category, _hit$category2;

  let {
    hit,
    index,
    onResultClick,
    context
  } = _ref15;
  const price = (_discountedPriceRange = discountedPriceRange(hit)) !== null && _discountedPriceRange !== void 0 ? _discountedPriceRange : priceRange(hit);
  const algoliaPosition = index + 1;
  const trackable = {
    // Google Analytics
    'data-ecomm-product': 'product',
    'data-product-brand': (_hit$brand$name = (_hit$brand = hit.brand) === null || _hit$brand === void 0 ? void 0 : _hit$brand.name) !== null && _hit$brand$name !== void 0 ? _hit$brand$name : '',
    'data-product-retailer': hit.shop.name,
    'data-product-retailer-id': (_hit$shop$retailer$sy = (_hit$shop$retailer = hit.shop.retailer) === null || _hit$shop$retailer === void 0 ? void 0 : _hit$shop$retailer.sys.id) !== null && _hit$shop$retailer$sy !== void 0 ? _hit$shop$retailer$sy : '',
    'data-product-category': (_hit$category = (_hit$category2 = hit.category) === null || _hit$category2 === void 0 ? void 0 : _hit$category2[hit.category.length - 1]) !== null && _hit$category !== void 0 ? _hit$category : '',
    'data-product-id': hit.variantGroupCode,
    'data-product-unique-id': makeUniqueProductId(hit.objectID, hit.shop.id, hit.variant.sku),
    'data-product-name': hit.name,
    'data-product-price': displayMinimumPriceWithoutCurrency(price),
    'data-product-list': 'Search',
    'data-product-variant': '',
    'data-product-variant-sku': hit.variant.sku,
    'data-product-currency': 'AUD',
    'data-product-position': index + 1,
    // Algolia Insights
    'data-insights-object-id': hit.objectID,
    'data-insights-position': algoliaPosition
  };
  return /*#__PURE__*/_jsx(AnalyticsDataWrapper, _objectSpread(_objectSpread({}, trackable), {}, {
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_AnalyticsDataWrapper",
    children: /*#__PURE__*/_jsx(ProductCard, {
      product: hit,
      analytics: {
        queryID: context.queryID,
        indexName: context.indexName,
        position: algoliaPosition
      },
      priceRange: priceRange(hit),
      discountedPriceRange: discountedPriceRange(hit),
      discountPercentageRange: discountPercentageRange(hit),
      onClick: () => onResultClick(hit),
      "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_AnalyticsDataWrapper_ProductCard"
    })
  }), [hit.variantGroupCode, hit.shop.id].join('/'));
};

const renderWestfieldProduct = _ref16 => {
  let {
    hit,
    onResultClick,
    context
  } = _ref16;
  return /*#__PURE__*/_jsx(WestfieldProductCard, {
    westfieldProduct: hit,
    mkpCartCount: context.mkpCartCount,
    onClick: () => onResultClick(hit),
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_WestfieldProductCard"
  }, hit.objectID);
};

const renderProductCollection = _ref17 => {
  let {
    hit,
    index,
    onResultClick,
    context
  } = _ref17;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: false,
    imageUrl: hit.img,
    hitKind: "product-collection",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult"
  }));
};

const renderBrand = _ref18 => {
  let {
    hit,
    index,
    onResultClick,
    context
  } = _ref18;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "brand",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_17"
  }));
};

const renderFacetBrand = _ref19 => {
  let {
    hit,
    index,
    onResultClick,
    context
  } = _ref19;
  return /*#__PURE__*/_createElement(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    key: hit.slug,
    hitKind: "brand",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_18"
  }));
};

const getRenderForSegment = _ref20 => {
  let {
    hit
  } = _ref20,
      rest = _objectWithoutProperties(_ref20, _excluded);

  switch (hit.segment) {
    case 'nationalStorefronts':
      return renderNationalStorefront(_objectSpread({
        hit
      }, rest));

    case 'stores':
      return renderStore(_objectSpread({
        hit
      }, rest));

    case 'sites':
      return renderSite(_objectSpread({
        hit
      }, rest));

    case 'services':
      return renderService(_objectSpread({
        hit
      }, rest));

    case 'localOffers':
      return renderLocalOffer(_objectSpread({
        hit
      }, rest));

    case 'nationalOffers':
      return renderNationalOffer(_objectSpread({
        hit
      }, rest));

    case 'events':
      return renderEvent(_objectSpread({
        hit
      }, rest));

    case 'news':
      return renderNews(_objectSpread({
        hit
      }, rest));

    case 'localStories':
      return renderLocalStory(_objectSpread({
        hit
      }, rest));

    case 'nationalStories':
      return renderNationalStory(_objectSpread({
        hit
      }, rest));

    case 'centres':
      return renderCentre(_objectSpread({
        hit
      }, rest));

    case 'onlineServices':
      return renderOnlineService(_objectSpread({
        hit
      }, rest));

    case 'otherStores':
      return renderNearCentreStore(_objectSpread({
        hit
      }, rest));

    case 'products':
      return renderProduct(_objectSpread({
        hit
      }, rest));

    case 'westfieldProducts':
      return renderWestfieldProduct(_objectSpread({
        hit
      }, rest));

    case 'productCollections':
      return renderProductCollection(_objectSpread({
        hit
      }, rest));

    case 'contentfulBrands':
      return renderBrand(_objectSpread({
        hit
      }, rest));

    case 'facetBrands':
      return renderFacetBrand(_objectSpread({
        hit
      }, rest));

    default:
      throw new Error("Unknown segment ".concat(hit.segment));
  }
}; // TODO rename this file and export


export default getRenderForSegment;